import { Inject, Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { Store } from "@ngrx/store";
import { HeaderConfigService } from "@obg/core.header";
import { CommonState } from "@obg/ngx.common";
import { CORE_ROUTE, STARTUP_CONTEXT_TOKEN, StartupContext } from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";
import { Observable, of } from "rxjs";

@Injectable({ providedIn: "root" })
export class OnlyForBotsGuard implements CanActivate {
	constructor(
		@Inject(STARTUP_CONTEXT_TOKEN) private startupContext: StartupContext,
		private headerConfigService: HeaderConfigService,
		private store: Store<CommonState>
	) {}

	canActivate(): Observable<boolean> {
		if (this.headerConfigService.isSportsbookSitemapEnabled() && this.startupContext.isBot === true) {
			return of(true);
		}
		this.store.dispatch(RouteAction.navigate(CORE_ROUTE.notFound));
		return of(false);
	}
}
